import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import TopNav from "../components/TopNav";
import BottomNav from "../components/BottomNav";
import Footer from "../components/footer/Footer";
import { ToastContainer, toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import { MdCall, MdEmail } from "react-icons/md";
import { BsTelephone, BsSend } from "react-icons/bs";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import "swiper/css";


import Amenities from "../makkaanpages/images/Avenue-18-DHA-Islamabad-2.webp";
import Avenue18_1 from "../makkaanpages/images/Avenue-18-DHA-Islamabad-3.png";
import Const2 from "../makkaanpages/images/Avenue-18-DHA-Islamabad-4.jpg";
import Const3 from "../makkaanpages/images/Avenue-18-DHA-Islamabad-5.png";
import Const4 from "../makkaanpages/images/Avenue-18-DHA-Islamabad-7.png";
import Const5 from "../makkaanpages/images/Avenue-18-DHA-Islamabad-6.png";

import Const6 from "../makkaanpages/images/Avenue_18_98.png";
import Const7 from "../makkaanpages/images/Avenue_18_99.webp";
import Const8 from "../makkaanpages/images/Avenue_18_construction.webp";
import Const9 from "../makkaanpages/images/Avenue_18_site.webp";

import Elevation from "../makkaanpages/images/Avenue-18-DHA-Islamabad-8.webp";
import Elevation1 from "../makkaanpages/images/Avenue-18-DHA-Islamabad-9.jpg";
import Elevation2 from "../makkaanpages/images/Avenue-18-DHA-Islamabad-10.jpg";
import Map1 from "../makkaanpages/images/Avenue-18-DHA-Islamabad-11.jpg";
import Map2 from "../makkaanpages/images/Avenue-18-DHA-Islamabad-12.jpg";
import Map3 from "../makkaanpages/images/Avenue-18-DHA-Islamabad-13.jpg";
import floor from "../makkaanpages/images/avenue18floor.png";
import payment from "../makkaanpages/images/Avenue-18-DHA-Islamabad-15.png";


import developerlogo from "../makkaanpages/images/avenue logo grey.png";
import makkaanLogo from "../makkaanpages/images/makkaanlogo.png";
import paymentplan from "../makkaanpages/pdf/AVENUE 18 PAYMENT PLAN final  22 april 2025.pdf";
import floorplan from "../makkaanpages/pdf/floor plan  avenue 18.pdf";
import Slider from "react-slick";

import "./CustomArrow.css";
import "../App.css";
import api_url from "../ApiUrl";
import axios from "axios";

import { SampleNextArrow, SamplePrevArrow } from "./CustomArrow";
import lightgreen from "../makkaanpages/images/lightgreen.jpg";

import ReactPlayer from "react-player";

function Avenue18() {
  const formRef = useRef();
  const paymentRef = useRef();

  const [isSticky, setIsSticky] = useState(false);
  const [isBottom, setIsBottom] = useState(false);
  const [paymentTop, setPaymentTop] = useState(0);
  const [formHeight, setFormHeight] = useState(0);
  const [modalImages, setModalImages] = useState([]);

  const [isFixed, setIsFixed] = useState(false);

  const [stickyLeft, setStickyLeft] = useState(0);

  const [modalImage, setModalImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showFormModal, setShowFormModal] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isExpandedd, setIsExpandedd] = useState(false);

  const [isExpandedMarketedBy, setIsExpandedMarketedBy] = useState(false);
  const [isExpandedDevelopedBy, setIsExpandedDevelopedBy] = useState(false);

  const toggleMarketedBy = () => {
    setIsExpandedMarketedBy((prev) => !prev);
  };

  const toggleDevelopedBy = () => {
    setIsExpandedDevelopedBy((prev) => !prev);
  };

  const fullText = `Makkaan.com has launched Avenue 18, a premier commercial
  project redefining investment opportunities in DHA Phase 1, Islamabad. Perfectly positioned on the DHA Phase 4 main
  link road, this architectural marvel is located in the heart of a rapidly expanding commercial hub, making it an
  ideal destination for businesses and investors. With its three open sides, 7-story design, and a stunning 20-ft
  atrium, Avenue 18 stands as a beacon of modern architecture and functionality. Offering premium spaces
  for shops, food courts, and offices, the project boasts a grand entrance, high-speed elevators, and state-of-the-art
  facilities to meet the demands of dynamic business environments. Avenue 18 by Makkaan.com, ensures a
  future-ready investment with guaranteed on-time delivery in 3 years and a flexible 4-year payment plan.`;

  const [navOffset, setNavOffset] = useState(0);
  const [hasReachedPayment, setHasReachedPayment] = useState(false);

  useEffect(() => {
    if (formRef.current) {
      setFormHeight(formRef.current.offsetHeight);
    }
  }, [formRef.current]);

  const getImageUrlForStage = (stageId) => {
    const selectedStage = stages.find((stage) => stage.id === stageId);
    if (selectedStage && selectedStage.images.length > 0) {
      return selectedStage.images[0]; // show first image for now
    }
    return "";
  };
  const handleImageClick = (stageId) => {
    const selectedStage = stages.find((stage) => stage.id === stageId);
    if (selectedStage) {
      setModalImages(selectedStage.images);
      setShowModal(true);
    }
  };

  const stages = [
    { id: 1, label: "Dec 2024", images: [Avenue18_1] },
    { id: 2, label: "March 2025", images: [Const4, Const3] },
    { id: 3, label: "Sep 2025", images: [Const9, Const6,Const7, Const8] },
     { id: 4, label: "Dec 2025", images: [Const9, Const6,Const7, Const8] },
  ];

  const [activeStage, setActiveStage] = useState(stages[stages.length - 1].id);

  const overviewRef = useRef(null);
  const developmentRef = useRef(null);
  const locationRef = useRef(null);
  const navRef = useRef(null);

  const scrollPosition = window.scrollY || window.pageYOffset;
  const formOffset = formRef.current?.offsetTop || 0;
  const paymentBottom =
    paymentRef.current?.offsetTop + paymentRef.current?.offsetHeight || 0;

  // Scroll handler for the enquiry form
  const overviewTop = 300;

  useEffect(() => {
    const updatePositions = () => {
      if (paymentRef.current && formRef.current) {
        setPaymentTop(paymentRef.current.offsetTop);
        setFormHeight(formRef.current.offsetHeight);
      }
    };

    updatePositions();
    window.addEventListener("resize", updatePositions);
    return () => window.removeEventListener("resize", updatePositions);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY || window.pageYOffset;

      if (!formRef.current || !paymentRef.current || !overviewRef.current)
        return;

      const formHeight = formRef.current.offsetHeight;
      const formOffset = formRef.current.offsetTop;
      const paymentBottom =
        paymentRef.current.offsetTop + paymentRef.current.offsetHeight;
      const overviewTop = overviewRef.current.offsetTop;

      // If above form or overview section
      if (scrollPosition < overviewTop) {
        setIsSticky(false);
        setIsBottom(false);
        return;
      }

      // Sticky state
      if (scrollPosition > 50 && scrollPosition + formHeight < paymentBottom) {
        if (!isSticky) {
          const rect = formRef.current.getBoundingClientRect();
          setStickyLeft(rect.left);
        }
        setIsSticky(true);
        setIsBottom(false);
      }
      // Reached bottom of Payment section
      else if (scrollPosition + formHeight >= paymentBottom) {
        setIsSticky(false);
        setIsBottom(true);
      }
      // Default fallback
      else {
        setIsSticky(false);
        setIsBottom(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // Initial check

    return () => window.removeEventListener("scroll", handleScroll);
  }, [isSticky]);

  // Scroll handler for the navigation bar
  useEffect(() => {
    window.scrollTo(0, 0);
    if (navRef.current) {
      setNavOffset(navRef.current.offsetTop);
    }

    const handleNavScroll = () => {
      if (window.pageYOffset >= navOffset) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleNavScroll);
    return () => {
      window.removeEventListener("scroll", handleNavScroll);
    };
  }, [navOffset]);

  const shortenedText = `${fullText.slice(0, 300)}...`; // Limit to 150 characters

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  const handleNext = () => {
    const currentIndex = stages.findIndex((stage) => stage.id === activeStage);
    const nextIndex = (currentIndex + 1) % stages.length;
    setActiveStage(stages[nextIndex].id);
  };

  const handlePrev = () => {
    const currentIndex = stages.findIndex((stage) => stage.id === activeStage);
    const prevIndex = (currentIndex - 1 + stages.length) % stages.length;
    setActiveStage(stages[prevIndex].id);
  };

  var settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const settingss = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const handleScrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  /* global fbq */

  const submit = () => {
    const fullName = document.getElementById("fullName");
    const phone = document.getElementById("phone");
    const email = document.getElementById("email");

    if (!fullName?.value?.trim()) {
      toast.error("Please enter your name");
      return;
    }
    if (!phone?.value?.trim()) {
      toast.error("Please enter your phone number");
      return;
    }

    const params = {
      fullName: fullName.value.trim(),
      phone: phone.value.trim(),
      email: email?.value?.trim() || "",
    };

    axios
      .post(`${api_url}contact/create`, params)
      .then((res) => {
        if (res.data.status === "ok") {
          toast.success("Your message was submitted successfully!");

          // ✅ Facebook Pixel tracking
          if (typeof fbq !== "undefined") {
            fbq("track", "Lead");
            fbq("trackCustom", "FormSubmitted", {
              form: "Avenue18",
              ...params,
            });
          }

          // Clear form
          fullName.value = "";
          phone.value = "";
          if (email) email.value = "";

          setTimeout(() => {
            window.location.reload();
          }, 3000);
        } else {
          toast.error(res.data.message || "Error submitting your message");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error("An unexpected error occurred. Please try again later.");
      });
  };

  return (
    <>
      <Helmet>
        <title>Avenue 18 DHA Phase 1, Islamabad - Payment Plan</title>
        <meta
          name="description"
          content="
Discover the payment plan of premium shops and offices for sale at Avenue 18 DHA Phase 1, Islamabad with Makkaan, Pakistan's leading property portal. "
        />
        <link rel="canonical" href="https://makkaan.com/avenue-18" />
      </Helmet>

      <div className="position-relative view_property">
        <ToastContainer />

        <div
          className=" position-fixed w-100"
          style={{ zIndex: "999999", marginTop: "-8em" }}
        >
          <TopNav />
          <BottomNav />
        </div>

        <div style={{ marginTop: "8em", zIndex: "0" }}>
          <div className="container mb-3">
            <div className="d-flex align-items-center justify-content-between flex-wrap ">
              <div className="d-flex align-items-center mt-2">
                <img
                  src={developerlogo} // or use the imported image
                  alt="Project Logo"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    marginRight: "1em",
                  }}
                />
                <div>
                  <h4
                    className="mb-0"
                    style={{ fontSize: "25px", color: "#4db749", zIndex: 10 }}
                  >
                    Avenue 18 Islamabad
                  </h4>
                  <small className="text-muted">
                    <i
                      className="fas fa-map-marker-alt"
                      style={{
                        color: "#4db749",
                        marginRight: "5px",
                        fontSize: "0.85rem", // smaller size
                        verticalAlign: "middle",
                      }}
                    ></i>
                    DHA Phase 1, Islamabad
                  </small>
                </div>
              </div>
              <div>
                <h5 className="mb-0">
                  <small className="text-muted">
                    STARTING FROM <br />
                  </small>
                  <span style={{ fontSize: "22px" }}>PKR </span>

                  <strong
                    style={{ fontSize: "25px", color: "#4db749", zIndex: 10 }}
                  >
                    60 Thousand to 90 Thousand
                  </strong>
                </h5>
              </div>
            </div>
          </div>

          <div className="container mt-3 mb-3">
            <div className="row">
              <div className="col-sm-8">
                <Slider {...settings}>
                  <div>
                    <img
                      loading="lazy"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      src={Elevation}
                      alt="Avenue-18-DHA-Islamabad-8"
                      style={{
                        width: "100%",
                        height: "auto",
                        cursor: "pointer",
                      }}
                    />
                  </div>

                  <div>
                    <img
                      loading="lazy"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      src={Const3}
                      alt="Avenue-18-DHA-Islamabad-5"
                      style={{
                        width: "100%",
                        height: "auto",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  <div>
                    <img
                      loading="lazy"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      src={Map1}
                      alt="Avenue-18-DHA-Islamabad-11"
                      style={{
                        width: "100%",
                        height: "auto",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  <div>
                    <img
                      loading="lazy"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      src={Map2}
                      alt="Avenue-18-DHA-Islamabad-12"
                      style={{
                        width: "100%",
                        height: "auto",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  <div>
                    <img
                      loading="lazy"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      src={Map3}
                      alt="Avenue-18-DHA-Islamabad-13"
                      style={{
                        width: "100%",
                        height: "auto",
                        cursor: "pointer",
                      }}
                    />
                  </div>

                  <div>
                    <img
                      loading="lazy"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      src={Const4}
                      alt="Avenue-18-DHA-Islamabad-7"
                      style={{
                        width: "100%",
                        height: "auto",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  <div>
                    <img
                      loading="lazy"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      src={Elevation1}
                      alt="Avenue-18-DHA-Islamabad-9"
                      style={{
                        width: "100%",
                        height: "auto",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  <div>
                    <img
                      loading="lazy"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      src={Const2}
                      alt="Avenue-18-DHA-Islamabad-4"
                      style={{
                        width: "100%",
                        height: "auto",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  

                  
                  <div>
                    <img
                      loading="lazy"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      src={Const5}
                      alt="Avenue-18-DHA-Islamabad-6"
                      style={{
                        width: "100%",
                        height: "auto",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  <div>
                    <img
                      loading="lazy"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      src={Const6}
                      alt="Avenue-18-DHA-Islamabad-6"
                      style={{
                        width: "100%",
                        height: "auto",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  <div>
                    <img
                      loading="lazy"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      src={Const7}
                      alt="Avenue-18-DHA-Islamabad-6"
                      style={{
                        width: "100%",
                        height: "auto",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  <div>
                    <img
                      loading="lazy"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      src={Const8}
                      alt="Avenue-18-DHA-Islamabad-6"
                      style={{
                        width: "100%",
                        height: "auto",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  <div>
                    <img
                      loading="lazy"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      src={Const9}
                      alt="Avenue-18-DHA-Islamabad-6"
                      style={{
                        width: "100%",
                        height: "auto",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  <div>
                    <img
                      loading="lazy"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      src={Elevation2}
                      alt="Avenue-18-DHA-Islamabad-10"
                      
                      style={{
                        width: "100%",
                        height: "auto",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </Slider>
              </div>
              <div className="col-sm-4">
                <img
                  className="imagedata"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                  src={Elevation2}
                  alt="Avenue-18-DHA-Islamabad-10"
                  loading="lazy"
                  style={{ width: "100%", height: "auto", cursor: "pointer" }}
                />
                <img
                  className="imagedata"
                  id="overview"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                  src={Elevation1}
                  alt="Avenue-18-DHA-Islamabad-9"
                  style={{
                    width: "100%",
                    height: "auto",
                    paddingTop: "0.89em",
                    cursor: "pointer",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container d-flex">
          <a href="#home-tab">
            <i
              className="bi bi-camera mx-2 icon-dark-bg"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
              onClick={() => document.getElementById("home-tab").click()}
              style={{ cursor: "pointer" }}
            ></i>
          </a>
          <a href="#profile-tab">
            <i
              className="bi bi-camera-reels mx-2"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
              onClick={() => document.getElementById("profile-tab").click()}
              style={{ cursor: "pointer" }}
            ></i>
          </a>
          <a>
            <i
              className="bi bi-geo-alt mx-2"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
              onClick={() => document.getElementById("contact-tab").click()}
              style={{ cursor: "pointer" }}
            ></i>
          </a>
        </div>

        <div
          class="modal fade"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
          style={{ zIndex: "100000000000" }}
        >
          <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">
                  Avenue 18
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active"
                      id="home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#home"
                      type="button"
                      role="tab"
                      aria-controls="home"
                      aria-selected="true"
                    >
                      Images
                    </button>
                  </li>

                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="profile-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#profile"
                      type="button"
                      role="tab"
                      aria-controls="profile"
                      aria-selected="false"
                    >
                      Videos
                    </button>
                  </li>

                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="contact-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#contact"
                      type="button"
                      role="tab"
                      aria-controls="contact"
                      aria-selected="false"
                    >
                      Map
                    </button>
                  </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div
                    class="tab-pane fade show active"
                    id="home"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                  >
                    <div className="slider-container p-5">
                      <Slider {...settingss}>
                        <div>
                          <img
                            loading="lazy"
                            src={Elevation}
                            alt="Avenue-18-DHA-Islamabad-8"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>

                        <div>
                          <img
                            loading="lazy"
                            src={Const5}
                            alt="Avenue-18-DHA-Islamabad-6"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>

                        <div>
                          <img
                            loading="lazy"
                            src={Const6}
                            alt="Avenue-18-DHA-Islamabad-6"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>
                        <div>
                          <img
                            loading="lazy"
                            src={Const7}
                            alt="Avenue-18-DHA-Islamabad-6"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>
                        <div>
                          <img
                            loading="lazy"
                            src={Const8}
                            alt="Avenue-18-DHA-Islamabad-6"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>
                        <div>
                          <img
                            loading="lazy"
                            src={Const9}
                            alt="Avenue-18-DHA-Islamabad-6"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>
                        <div>
                          <img
                            loading="lazy"
                            src={Map1}
                            alt="Avenue-18-DHA-Islamabad-11"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>
                        <div>
                          <img
                            loading="lazy"
                            src={Map2}
                            alt="Avenue-18-DHA-Islamabad-12"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>
                        <div>
                          <img
                            loading="lazy"
                            src={Map3}
                            alt="Avenue-18-DHA-Islamabad-13"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>

                        <div>
                          <img
                            loading="lazy"
                            src={Elevation1}
                            alt="Avenue-18-DHA-Islamabad-9"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>

                        <div>
                          <img
                            loading="lazy"
                            src={Const4}
                            alt="Avenue-18-DHA-Islamabad-7"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>

                        <div>
                          <img
                            loading="lazy"
                            src={Const3}
                            alt="Avenue-18-DHA-Islamabad-5"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>

                        <div>
                          <img
                            loading="lazy"
                            src={Const2}
                            alt="Avenue-18-DHA-Islamabad-4"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>
                        <div>
                          <img
                            loading="lazy"
                            src={Elevation2}
                            alt="Avenue-18-DHA-Islamabad-10"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>
                        {/* <div>
                          <img
                            loading="lazy"
                            src={Avenue18_1}
                            alt="Avenue-18-DHA-Islamabad-3"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div> */}
                        

                       
                      </Slider>
                    </div>
                  </div>

                  <div
                    class="tab-pane fade"
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                  >
                    <div className="p-5">
                      <ReactPlayer
                        url="https://youtu.be/Pazb8lA441I"
                        controls={true}
                        width="100%"
                        height="450px"
                      />
                    </div>
                  </div>

                  <div
                    class="tab-pane fade"
                    id="contact"
                    role="tabpanel"
                    aria-labelledby="contact-tab"
                  >
                    <div className="p-5">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3325.2580379069223!2d73.08601697520385!3d33.54667144425763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfed8f1af16861%3A0x6394b0e09933c725!2sAvenue%2018%20DHA%201%20Islamabad!5e0!3m2!1sen!2s!4v1737807465604!5m2!1sen!2s"
                        width="100%"
                        height="400px"
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Mobile Div  */}

        <div className="fixed-bar">
          <button type="button" class="btn btn-primary">
            Contact Us
          </button>

          <a href="+923311111049">
            <button className="col-sm-4 btn fixed-button">
              <i class="bi bi-telephone"></i> Call
            </button>
          </a>
          <a href="http://wa.me/+923311111045">
            <button className="col-sm-4 btn fixed-button">
              <i class="bi bi-whatsapp"></i>
            </button>
          </a>
        </div>

        {/* Tabs bars  */}
        <div
          ref={navRef}
          className={`mid-nav ${isFixed ? "fixed" : ""}`}
          id="midNav"
          style={{ zIndex: "10000000" }}
        >
          <div className="nav-buttons-container py-3">
            <button
              className="nav-button"
              onClick={() => handleScrollToSection("overview")}
            >
              Overview
            </button>

            <button
              className="nav-button"
              onClick={() => handleScrollToSection("development")}
            >
              Development Updates
            </button>
            <button
              className="nav-button"
              onClick={() => handleScrollToSection("location")}
            >
              Location
            </button>
            <button
              className="nav-button"
              onClick={() => handleScrollToSection("payment")}
            >
              Payment Plans Floor Plans
            </button>
            <button
              className="nav-button"
              onClick={() => handleScrollToSection("FAQ's")}
            >
              FAQ's
            </button>
            <button
              className="nav-button"
              onClick={() => handleScrollToSection("marketed")}
            >
              Developed By
            </button>
          </div>
        </div>
        <div className="container mt-3">
          <div className="row">
            <div className="col-lg-8">
              <div className="row">
                <div className="col-12">
                  <div className="read-more-container" ref={overviewRef}>
                    <h2
                      style={{
                        color: "#4db749",
                        fontWeight: "bold",
                        fontSize: "22px",
                      }}
                    >
                      Overview
                    </h2>

                    {/* <div>
                      <p style={{ paddingTop: "1em" }}>
                        {isExpandedd ? fullText : shortenedText}
                      </p>
                      <button
                        onClick={() => setIsExpandedd(!isExpandedd)}
                        style={{
                          color: "#4db749",
                          border: "none",
                          background: "transparent",
                          cursor: "pointer",
                          fontSize: "13px",
                        }}
                      >
                        {isExpandedd ? "Show Less" : "Show More"}
                      </button>
                    </div> */}

                    <li className="d-flex justify-content-between align-items-center p-3">
                      {/* Left Section: Icon + Text */}
                      <div className="d-flex align-items-center">
                        <i
                          className="bi bi-geo-alt me-2"
                          style={{
                            fontSize: "20px",
                            color: "#4db749",
                            zIndex: 10,
                          }}
                        ></i>
                        <div className="d-flex flex-column">
                          <span style={{ fontSize: "14px" }}>Location</span>
                          <div className="fw-bold">DHA 1 Islamabad</div>
                        </div>
                      </div>

                      {/* Right Section: Icon + Text */}
                      <div className="d-flex align-items-center">
                        <i
                          className="bi bi-person me-2"
                          style={{
                            fontSize: "20px",
                            color: "#4db749",
                            zIndex: 10,
                          }}
                        ></i>
                        <div className="d-flex flex-column">
                          <span style={{ fontSize: "14px" }}>Developer</span>
                          <div className="fw-bold">Makkaan Development</div>
                        </div>
                      </div>
                    </li>

                    <style>
                      {`
  .mid-nav {
    z-index: 100 !important;
  }
  .fixed-bar {
    z-index: 100 !important;
  }
  .position-fixed {
    z-index: 100 !important;
  }
  
  .accordion-item {
  border: 1px solid #dee2e6 !important;
  border-radius: 0.375rem;
  margin-bottom: 1rem;
  overflow: hidden; /* Keeps border-radius on child elements */
}

/* Header styling */
.accordion-button {
  border-bottom: 1px solid #dee2e6 !important;
  background-color: white;
}

/* Active header */
.accordion-button:not(.collapsed) {
  
  background-color: rgb(218, 237, 215) !important;
}

/* Remove double border when collapsed */
.accordion-button.collapsed {
  border-bottom-left-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

/* Remove the border from accordion-body */
.accordion-body {
background-color: rgb(218, 237, 215) !important;
  border: none !important;
}
  
  `}
                    </style>

                    <div className="accordion mt-5" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingOne">
                          <button
                            className="accordion-button collapsed d-flex align-items-center w-100"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                            style={{
                              backgroundColor: "",
                              paddingTop: "40px",
                              paddingBottom: "40px",
                              border: "none",
                            }}
                          >
                            {/* Left Section: Icon + Text */}
                            <div className="d-flex align-items-center">
                              <i
                                className="bi bi-shop me-2"
                                style={{
                                  fontSize: "20px",
                                  color: "#4db749",
                                  zIndex: 10,
                                }}
                              ></i>
                              <span className="fw-bold">Shops</span>
                            </div>

                            {/* Spacer to push content to the right */}
                            <div className="flex-grow-1"></div>

                            {/* Right Section: Price + Dropdown Icon */}
                            <div className="d-flex align-items-center">
                              <span
                                className="text-muted me-1"
                                style={{ fontSize: "12px" }}
                              >
                                PKR
                              </span>
                              <span className="fw-bold me-1">
                                60 Thousand to
                                <span className="mobile-break">
                                  <br />
                                </span>{" "}
                                1.05 lac
                              </span>
                            </div>
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          className="collapse"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <li
                              className=" d-flex justify-content-between align-items-center p-3 shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div
                                className="d-flex flex-column"
                                style={{ backgroundColor: "white" }}
                              >
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  Lower Ground Shops
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Area Size: Per sq.ft</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>
                                60 Thousand
                              </div>
                            </li>

                            <li
                              className="d-flex justify-content-between align-items-center p-3 shadow-sm rounded mt-4 mb-4"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  Ground Floor Shops
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Area Size: Per sq.ft</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>
                                90 Thousand
                              </div>
                            </li>
                            <li
                              className="d-flex justify-content-between align-items-center p-3 shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  First Floor Shops
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Area Size: Per sq.ft</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>
                                65 Thousand
                              </div>
                            </li>
                            <li
                              className="d-flex justify-content-between align-items-center p-3 mt-4 mb-4  shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  2nd Floor Shops
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Area Size: Per sq.ft</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>
                                50 to 3.75 Thousand
                              </div>
                            </li>
                            <li
                              className="d-flex justify-content-between align-items-center p-3   shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  3rd Floor Shops
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Area Size: Per sq.ft</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>
                                29 to 43 Thousand
                              </div>
                            </li>
                          </div>
                        </div>
                      </div>

                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            className="accordion-button  d-flex align-items-center w-100 collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-controls="collapseTwo"
                            style={{
                              paddingTop: "40px",
                              paddingBottom: "40px",

                              border: "none",
                            }}
                          >
                            {/* Left Section: Icon + Text */}
                            <div className="d-flex align-items-center">
                              <i
                                className="bi bi-building me-2"
                                style={{
                                  fontSize: "20px",
                                  color: "#4db749",
                                  zIndex: 10,
                                }}
                              ></i>
                              <span className="fw-bold">Offices</span>
                            </div>

                            {/* Spacer to push content to the right */}
                            <div className="flex-grow-1"></div>

                            {/* Right Section: Price + Arrow */}
                            <div className="d-flex align-items-center">
                              <span
                                className="text-muted me-1"
                                style={{ fontSize: "12px" }}
                              >
                                PKR
                              </span>
                              <span className="fw-bold me-3">35 Thousand</span>
                            </div>
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          className="collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <li
                              className=" d-flex justify-content-between align-items-center p-3 shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  4th & 5th Floor Offices
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Area Size: Per sq.ft</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>{" "}
                                35 Thousand
                              </div>
                            </li>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div
                ref={formRef}
                className={`sticky-form d-none d-lg-block ${
                  isSticky ? "fixed" : ""
                } ${isBottom ? "bottom" : ""}`}
                style={{
                  backgroundImage: `url(${lightgreen})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  padding: "1.2em",
                  paddingTop: "0.8em",
                  paddingBottom: "1.5em",
                  borderRadius: "8px",
                  width: "100%",
                  maxWidth: "22em",
                  boxSizing: "border-box",
                  position: isSticky
                    ? "fixed"
                    : isBottom
                    ? "absolute"
                    : "relative",

                  // Lock the top and left when sticky
                  top: isSticky
                    ? "10em"
                    : isBottom
                    ? `${paymentBottom - formHeight}px`
                    : "auto",
                  left: isSticky ? stickyLeft : "auto", // <-- Add this line

                  transform: "none",
                  willChange: "transform",
                }}
              >
                <h4
                  className="text-center text-black mb-2"
                  style={{ fontSize: "16px", fontWeight: "600" }}
                >
                  MAKE AN ENQUIRY
                </h4>
                <div className="text-center mb-2">
                  <a
                    href="tel:03311111049"
                    className="text-decoration-none d-block"
                  >
                    <button
                      className="btn btn-success w-100 py-1"
                      style={{
                        backgroundColor: "#00B53F",
                        border: "none",
                        height: "32px",
                      }}
                    >
                      <BsTelephone className="me-2" />
                      Call Now
                    </button>
                  </a>
                  <div
                    className="text-center my-1"
                    style={{ fontSize: "13px", color: "#666" }}
                  >
                    or
                  </div>
                </div>
                <div>
                  <div className="mb-2">
                    <label
                      className="form-label mb-1"
                      style={{ fontSize: "13px", color: "#333" }}
                    >
                      Your Name *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="fullName"
                      placeholder="How should we address you?"
                      style={{
                        backgroundColor: "#fff",
                        border: "1px solid #ddd",
                        height: "32px",
                        fontSize: "13px",
                        borderRadius: "4px",
                      }}
                    />
                  </div>
                  <div className="mb-2">
                    <label
                      className="form-label mb-1"
                      style={{ fontSize: "13px", color: "#333" }}
                    >
                      Phone Number *
                    </label>
                    <div className="input-group">
                      <span
                        className="input-group-text"
                        style={{
                          backgroundColor: "#fff",
                          fontSize: "13px",
                          border: "1px solid #ddd",
                          borderRight: "none",
                          width: "75px",
                          height: "35px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src="https://flagcdn.com/w20/pk.png"
                          alt="PK"
                          style={{ width: "18px" }}
                          className="me-1"
                        />
                        +92
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        id="phone"
                        placeholder="Your phone number"
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #ddd",
                          borderLeft: "none",
                          height: "35px",
                          fontSize: "13px",
                          borderRadius: "0 4px 4px 0",
                          flex: "1",
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-2">
                    <label
                      className="form-label mb-1"
                      style={{ fontSize: "13px", color: "#333" }}
                    >
                      Email Address (Optional)
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="Your best email address?"
                      style={{
                        backgroundColor: "#fff",
                        border: "1px solid #ddd",
                        height: "32px",
                        fontSize: "13px",
                        borderRadius: "4px",
                      }}
                    />
                  </div>
                  <button
                    className="btn btn-success w-100 py-1 mt-2"
                    onClick={submit}
                    style={{
                      backgroundColor: "#00B53F",
                      border: "none",
                      height: "35px",
                      fontSize: "14px",
                      borderRadius: "4px",
                      fontWeight: "500",
                    }}
                  >
                    <BsSend className="me-2" />
                    Request Call
                  </button>
                  <div
                    className="text-center text-muted mt-2"
                    style={{ fontSize: "11px" }}
                  >
                    By submitting this form, you agree to{" "}
                    <a href="#" className="text-primary text-decoration-none">
                      Terms of Use
                    </a>
                    .
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile Form Button */}
            <div
              className="d-lg-none fixed-bottom bg-white p-3"
              style={{ boxShadow: "0 -2px 10px rgba(0,0,0,0.1)" }}
            >
              <button
                className="btn btn-success w-100"
                style={{ backgroundColor: "#00B53F" }}
                onClick={() => setShowFormModal(true)}
              >
                Make an Enquiry
              </button>
            </div>

            {/* Mobile Form Modal */}
            <Modal
              show={showFormModal}
              onHide={() => setShowFormModal(false)}
              centered
              style={{ zIndex: "9999999" }}
              dialogClassName="modal-on-top"
              contentClassName="position-relative"
            >
              <Modal.Header
                closeButton
                style={{
                  backgroundImage: `url(${lightgreen})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  border: "none",
                  paddingTop: "1.2em",
                  paddingBottom: "0",
                }}
              >
                <Modal.Title
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  MAKE AN ENQUIRY
                </Modal.Title>
              </Modal.Header>
              <Modal.Body
                style={{
                  backgroundImage: `url(${lightgreen})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  padding: "1.2em",
                }}
              >
                <div>
                  <div className="text-center mb-2">
                    <a
                      href="tel:03311111049"
                      className="text-decoration-none d-block"
                    >
                      <button
                        className="btn btn-success w-100 py-1"
                        style={{
                          backgroundColor: "#00B53F",
                          border: "none",
                          height: "32px",
                        }}
                      >
                        <BsTelephone className="me-2" />
                        Call Now
                      </button>
                    </a>
                    <div
                      className="text-center my-1"
                      style={{ fontSize: "13px", color: "#666" }}
                    >
                      or
                    </div>
                  </div>
                  <div>
                    <div className="mb-2">
                      <label
                        className="form-label mb-1"
                        style={{ fontSize: "13px", color: "#333" }}
                      >
                        Your Name *
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="fullName"
                        placeholder="How should we address you?"
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #ddd",
                          height: "32px",
                          fontSize: "13px",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                    <div className="mb-2">
                      <label
                        className="form-label mb-1"
                        style={{ fontSize: "13px", color: "#333" }}
                      >
                        Phone Number *
                      </label>
                      <div className="input-group">
                        <span
                          className="input-group-text"
                          style={{
                            backgroundColor: "#fff",
                            fontSize: "13px",
                            border: "1px solid #ddd",
                            borderRight: "none",
                            width: "75px",
                            height: "32px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src="https://flagcdn.com/w20/pk.png"
                            alt="PK"
                            style={{ width: "18px" }}
                            className="me-1"
                          />
                          +92
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          id="phone"
                          placeholder="Your phone number"
                          style={{
                            backgroundColor: "#fff",
                            border: "1px solid #ddd",
                            borderLeft: "none",
                            height: "32px",
                            fontSize: "13px",
                            borderRadius: "0 4px 4px 0",
                            flex: "1",
                          }}
                        />
                      </div>
                    </div>
                    <div className="mb-2">
                      <label
                        className="form-label mb-1"
                        style={{ fontSize: "13px", color: "#333" }}
                      >
                        Email Address (Optional)
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="Your best email address?"
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #ddd",
                          height: "32px",
                          fontSize: "13px",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                    <button
                      className="btn btn-success w-100 py-1 mt-2"
                      onClick={submit}
                      style={{
                        backgroundColor: "#00B53F",
                        border: "none",
                        height: "35px",
                        fontSize: "14px",
                        borderRadius: "4px",
                        fontWeight: "500",
                      }}
                    >
                      <BsSend className="me-2" />
                      Request Call
                    </button>
                    <div
                      className="text-center text-muted mt-2"
                      style={{ fontSize: "11px" }}
                    >
                      By submitting this form, you agree to{" "}
                      <a href="#" className="text-primary text-decoration-none">
                        Terms of Use
                      </a>
                      .
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col-lg-8">
              <div className="row">
                <div className="col-12">
                  <div className="read-more-container">
                    <h2
                      style={{
                        color: "#4db749",
                        fontWeight: "bold",
                        fontSize: "22px",
                      }}
                    >
                      Avenue 18
                    </h2>

                    <h1
                      style={{
                        color: "#4db749",
                      }}
                    >
                      Welcome to Avenue 18 DHA 1 – The Future of Business in
                      Islamabad
                    </h1>
                    <br />

                    <p>
                      Avenue 18 DHA 1 is a signature commercial project by
                      Makkaan Developments. This premier commercial hub in
                      Islamabad offers a unique blend of modern architecture,
                      strategic location, and potential business opportunities.
                      Avenue 18 caters to diverse business needs with
                      meticulously designed commercial spaces, corporate
                      offices, and recreational areas.
                      <br />
                      <br />
                      <h4 style={{ color: "#4db749" }} id="development">
                        Available Spaces at Avenue 18 DHA 1 Islamabad
                      </h4>
                      <br />
                      <p>
                        The following spaces are available for businesses and
                        investors to consider
                      </p>
                      <ol class="custom-list">
                        <li>
                          {" "}
                          <b>Retail Spaces:</b>Explore a variety of sizes to
                          suit your business needs.
                        </li>
                        <li>
                          {" "}
                          <b>Corporate Offices</b>Find the perfect innovative
                          workspace for your team, with customizable options
                          available.
                        </li>
                        <li>
                          {" "}
                          <b>Food Court Units</b>Join a vibrant culinary scene
                          and attract a diverse clientele.
                        </li>
                      </ol>
                    </p>
                    {isExpanded && (
                      <p>
                        <h4 style={{ color: "#4db749" }}>
                          Why invest in Avenue 18?
                        </h4>
                        Before exploring this premium commercial project, you
                        must know why it is a goldmine for businesses and
                        investors.
                        <ol>
                          <h5 style={{ color: "#4db749" }}>
                            <li>
                              <b>Prime Location</b>
                            </li>
                            <br />
                          </h5>
                          <p>
                            Avenue 18 DHA 1 Islamabad ensures easy connectivity
                            to key areas of the city. Its strategic location
                            attracts high foot traffic, making it the ultimate
                            destination for growing business, retail, and
                            vigorous recreational activities.
                          </p>
                          <h5 style={{ color: "#4db749" }}>
                            <li>
                              <b>Modern Architecture and Contemporary Design</b>
                            </li>
                          </h5>
                          <br />
                          <p>
                            The sleek architecture of Avenue 18 reflects
                            sophistication and innovation. With a focus on
                            user-experience, its well-ventilated wide corridors
                            and premium finishes make it a standout destination
                            for businesses and visitors.
                          </p>

                          <h5 style={{ color: "#4db749" }}>
                            <li>
                              <b>High Potential for Foot Traffic</b>
                            </li>
                            <br />
                          </h5>
                          <p>
                            Avenue 18 offers vibrant shopping, dining, and
                            corporate spaces for consistent visitor engagement.
                            It is designed to attract families, professionals,
                            and shoppers, making it a hotspot for growth. The
                            potential visitors are from DHA Phase 1, DHA Phase
                            2, Bahria Town, and nearby housing societies in
                            Islamabad.
                          </p>

                          <h5 style={{ color: "#4db749" }}>
                            <li>
                              <b>Versatile Spaces for Every Need</b>
                            </li>
                            <br />
                          </h5>
                          <p>
                            From retail shops and food courts to corporate
                            offices, Avenue 18 caters to diverse business needs.
                            Whether establishing a retail presence or seeking
                            the perfect workspace, Avenue 18 has you covered.
                          </p>

                          <h5 style={{ color: "#4db749" }}>
                            <li>
                              <b>State-of-the-Art Amenities</b>
                            </li>
                            <br />
                          </h5>
                          <p>
                            With a customer-centric approach, this premium
                            project in DHA phase 1 offers world-class amenities,
                            including
                          </p>
                          <ol class="custom-list">
                            <li>
                              Wide 6-foot corridors for smooth navigation and
                              exceptional experience
                            </li>
                            <li>High-speed elevators and ample parking</li>
                            <li>Advanced security systems</li>
                            <li>
                              Modern facilities tailored to retail, dining, and
                              corporate environments
                            </li>
                          </ol>
                        </ol>
                        <h4 style={{ color: "#4db749" }}>
                          Explore Avenue 18: Floor-by-Floor Overview
                        </h4>
                        <p>Here is the floor plan of Avenue 18.</p>
                        <h5 style={{ color: "#4db749" }}>
                          Lower Ground Floor – Ideal for Retail Businesses
                        </h5>
                        <p>
                          The lower ground floor is reserved for commercial
                          shops, offering businesses an ideal platform to
                          establish a retail presence.
                        </p>
                        <ol class="custom-list">
                          <li>
                            <b>Shop Sizes:</b> The shop sizes vary from 200 to
                            255 sq. ft. to accommodate different business needs.
                          </li>
                          <li>
                            <b>Features:</b>A well-planned 6-foot-wide corridor
                            for smooth customer flow and convenient entrances.
                          </li>
                          <li>
                            <b>Availability:</b>A mix of sold-out and available
                            spaces.
                          </li>
                          <li>
                            <b>Why Choose This Floor:</b> High visibility and
                            accessibility make it perfect for retail brands
                            looking to attract foot traffic.
                          </li>
                        </ol>
                        <h5 style={{ color: "#4db749" }}>
                          Ground Floor – Premium Commercial Spaces
                        </h5>
                        <p>
                          The ground floor of Avenue 18 DHA 1 offers premium
                          shops.
                        </p>
                        <ol class="custom-list">
                          <li>
                            <b>Shop Sizes:</b> 200 to 255 sq. ft.
                          </li>
                          <li>
                            <b>Strategic Positioning:</b> Prime frontage and
                            easy accessibility ensure maximum visibility.
                          </li>
                          <li>
                            <b>Wide Corridors:</b> A welcoming atmosphere for
                            retailers and customers alike.
                          </li>
                          <li>
                            <b>Why Choose This Floor:</b> It offers excellent
                            exposure and high traffic, which is ideal for
                            prestigious brands.
                          </li>
                        </ol>
                        <h5 style={{ color: "#4db749" }}>
                          First Floor – Versatile Commercial and Retail Spaces
                        </h5>
                        <p>
                          This floor balances functionality and variety, making
                          it perfect for retailers.
                        </p>
                        <ol class="custom-list">
                          <li>
                            <b>Shop Sizes:</b> 140 to 225 sq. ft
                          </li>
                          <li>
                            <b>Features:</b> A 20-foot-wide central atrium
                            creates an open ambiance. There are 6-foot-wide
                            corridors to ensure convenience.
                          </li>

                          <li>
                            <b>Why Choose This Floor:</b> The well-thought-out
                            layout enhances customer experiences, ensuring
                            steady footfall.
                          </li>
                        </ol>
                        <h5 style={{ color: "#4db749" }}>
                          Second Floor – A Commercial Hub
                        </h5>
                        <p>
                          This floor at Avenue 18 is designed to facilitate
                          retailers and commercial activities
                        </p>
                        <ol class="custom-list">
                          <li>
                            <b>Purpose:</b> Flexible spaces perfect for
                            expanding businesses.
                          </li>
                          <li>
                            <b>Why Choose This Floor:</b> Accessibility and
                            modern layouts create an inviting environment for
                            retailers and customers.
                          </li>
                        </ol>
                        <h5 style={{ color: "#4db749" }}>
                          Third Floor – The Ultimate Food Court
                        </h5>
                        <p>
                          The food court attracts shoppers and visitors with its
                          irresistible food aromas.
                        </p>
                        <ol class="custom-list">
                          <li>
                            <b>Dining Spaces:</b> Multiple food outlets with
                            ample seating and a cozy ambiance.
                          </li>
                          <li>
                            <b>Modern Amenities:</b> Ventilation, advanced
                            kitchen facilities, and spacious seating areas.
                          </li>
                          <li>
                            <b>Why Choose This Floor:</b> This floor is a
                            perfect fit for food entrepreneurs.
                          </li>
                        </ol>
                        <h3>Don't Miss Out – Secure Your Spot at Avenue 18!</h3>
                        <p>
                          Opportunities like Avenue 18 don't come around often.
                          With its prime location, modern design, and high
                          footfall potential, spaces are filling up fast. Call
                          us today or visit{" "}
                          <a href="https://www.makkaan.com/" target="_blank">
                            {" "}
                            Makkaan.com
                          </a>{" "}
                          to learn about Avenue 18 payment plans and booking
                          details. Don't let this chance slip away – the future
                          of your business starts here!
                        </p>
                        <div></div>
                      </p>
                    )}
                    <a
                      onClick={toggleReadMore}
                      style={{ color: "green", cursor: "pointer" }}
                    >
                      {isExpanded ? "Read Less" : "Read More"}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-5" ref={developmentRef}>
          <div className="row">
            <div className="col-lg-8">
              <div className="read-more-container">
                <h2
                  style={{
                    color: "#4db749",
                    fontWeight: "bold",
                    fontSize: "22px",
                  }}
                >
                  Development Updates for Avenue 18
                </h2>

                <div className="row">
                  {/* Timeline first */}
                  <div className="col-12">
                    <div className="timeline">
                      {stages.map((stage, index) => (
                        <div
                          key={stage.id}
                          className="timeline-stage"
                          style={{ overflow: "hidden" }}
                        >
                          <div
                            className={`circle ${
                              activeStage === stage.id ? "active" : ""
                            }`}
                            onClick={() => setActiveStage(stage.id)}
                          >
                            <>
                              {stage.label.split(" ")[0]} <br />
                              {stage.label.split(" ")[1]} <br />
                              {stage.label.split(" ")[2]}
                            </>
                          </div>
                          {index < stages.length - 1 && (
                            <div className="line"></div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Images or Slider */}
                  <div className="col-12 mt-4">
                    <div className="timeline-images">
                      {stages
  .filter((stage) => stage.id === activeStage)
  .map((stage) =>
    stage.images.length > 1 ? (
      <div className="slider-container" key={stage.id}>
        <Slider {...settingss}>
          {stage.images.map((src, idx) => (
            <div key={idx}>
              <img
                loading="lazy"
                src={src}
                alt={`${stage.label}-image-${idx}`}
                style={{ width: "100%", height: "auto" }}
              />
            </div>
          ))}
        </Slider>
      </div>
    ) : (
      <img
        key={stage.id}
        src={stage.images[0]}
        alt={`${stage.label}-preview`}
        style={{
          width: "100%",
          height: "auto",
          marginBottom: "20px",
          objectFit: "cover",
          borderRadius: "10px",
        }}
      />
    )
  )}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="location"></div>
        </div>

        <div className="container mt-5" ref={locationRef}>
          <div className="row">
            <div className="col-lg-8">
              <div className="row">
                <div className="col-12">
                  <div className="read-more-container">
                    <h2
                      style={{
                        color: "#4db749",
                        fontWeight: "bold",
                        fontSize: "22px",
                      }}
                    >
                      Location
                    </h2>

                    <div className="row mt-3">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3325.2580379069223!2d73.08601697520385!3d33.54667144425763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfed8f1af16861%3A0x6394b0e09933c725!2sAvenue%2018%20DHA%201%20Islamabad!5e0!3m2!1sen!2s!4v1737807465604!5m2!1sen!2s"
                        width="600"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Google Map"
                      ></iframe>
                      <div id="payment"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-5" ref={paymentRef}>
          <div className="row">
            <div className="col-lg-8">
              <div className="row">
                <div className="col-12">
                  <div className="read-more-container">
                    <h2
                      style={{
                        color: "#4db749",
                        fontWeight: "bold",
                        fontSize: "22px",
                      }}
                    >
                      Payment & Floor plans For Avenue 18 DHA 1 Islamabad
                    </h2>

                    <div class="row">
                      <div class="col-sm-12 col-md-6 col-lg-4">
                        <div className="card" style={{ width: "100%" }}>
                          <div className="row">
                            <a
                              href={paymentplan}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                loading="lazy"
                                src={payment}
                                className="card-img-top"
                                alt="Avenue18-paymentplan"
                                style={{ padding: "10px", borderRadius: "5px" }}
                              />
                            </a>
                            <div className="card-body">
                              <p className="card-text">Avenue18 Payment Plan</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-6 col-lg-4">
                        <div className="card" style={{ width: "100%" }}>
                          <a
                            href={floorplan}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              loading="lazy"
                              src={floor}
                              className="card-img-top"
                              alt="Avenue18-floorplan"
                              style={{ padding: "10px", borderRadius: "5px" }}
                            />
                          </a>
                          <div className="card-body" id="FAQ's">
                            <p className="card-text">Avenue18 Floor plans</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-3" ref={paymentRef}>
          <div className="row">
            <div className="col-lg-8">
              <div className="col-12">
                <div className="read-more-container">
                  <h2
                    style={{
                      color: "#4db749",
                      fontWeight: "bold",
                      fontSize: "22px",
                    }}
                  >
                    FAQ's
                  </h2>

                  <div class="accordion mt-3" id="accordionExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          Q1: What sizes of commercial shops are available at
                          Avenue 18?
                        </button>
                      </h2>
                      <div
                        id="collapseThree"
                        className="accordion-collapse collapse"
                      >
                        <div className="accordion-body lh-base">
                          A: Shop sizes range from 140 sq. ft. to 255 sq. ft.,
                          catering to various business needs.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefour"
                          aria-expanded="false"
                          aria-controls="collapsefour"
                        >
                          Q2: Where is Avenue 18 located?
                        </button>
                      </h2>
                      <div
                        id="collapsefour"
                        className="accordion-collapse collapse"
                      >
                        <div className="accordion-body lh-base">
                          A: Avenue 18 is located in DHA Phase 1, Islamabad.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFive"
                          aria-expanded="false"
                          aria-controls="collapseFive"
                        >
                          Q3: What amenities are available at Avenue 18 DHA 1?
                        </button>
                      </h2>
                      <div
                        id="collapseFive"
                        className="accordion-collapse collapse"
                      >
                        <div className="accordion-body lh-base">
                          A: Avenue 18 offers high-speed elevators, advanced
                          security systems, ample parking, wide corridors, and
                          modern facilities tailored to retail, dining, and
                          corporate needs.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header" id="marketed">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseSix"
                          aria-expanded="false"
                          aria-controls="collapseSix"
                        >
                          Q4: Is Avenue 18 suitable for startups?
                        </button>
                      </h2>
                      <div
                        id="collapseSix"
                        className="accordion-collapse collapse"
                      >
                        <div className="accordion-body lh-base">
                          A: With flexible payment plans and customizable
                          corporate spaces, Avenue 18 is perfect for startups.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseSeven"
                          aria-expanded="false"
                          aria-controls="collapseSeven"
                        >
                          Q5: How do I book a space at Avenue 18 DHA 1
                          Islamabad?
                        </button>
                      </h2>
                      <div
                        id="collapseSeven"
                        className="accordion-collapse collapse"
                      >
                        <div className="accordion-body lh-base">
                          A: Contact us now to secure your spot in the capital's
                          most sought-after commercial hub.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mb-3 mt-3">
          <div className="row">
            <div className="col-md-6 mb-3">
              <div
                className="card"
                style={{
                  minHeight: isExpandedMarketedBy ? "auto" : "250px",
                  transition: "min-height 0.3s ease",
                }}
              >
                <div className="row g-0">
                  <div className="col-md-4">
                    <img
                      loading="lazy"
                      src={makkaanLogo}
                      className="img-fluid rounded-start"
                      alt="Makkaan-logo"
                      style={{ padding: "15px", marginTop: "25px" }}
                    />
                  </div>
                  <div className="col-md-8">
                    <div className="card-body">
                      <h3 className="card-title">Marketed By</h3>
                      <h5 className="card-title">Makkaan.com</h5>
                      <p>
                        Makkaan.com is a trustworthy and responsible platform
                        that aims to provide you with all the Residential,
                        Commercial, and Investment details under the same roof.
                        The only podium that offers reliable services to
                        investors, dealers, societies,
                      </p>
                      {isExpandedMarketedBy && (
                        <p>
                          and end-users of the real estate world throughout the
                          country. We use an all-inclusive marketing strategy
                          that covers all aspects of projects and helps
                          investors at every stage of the process with complete
                          transparency.
                        </p>
                      )}
                      <a
                        onClick={toggleMarketedBy}
                        style={{ color: "green", cursor: "pointer" }}
                      >
                        {isExpandedMarketedBy ? "Read Less" : "Read More"}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-3">
              <div
                className="card"
                style={{
                  minHeight: isExpandedDevelopedBy ? "auto" : "250px",
                  transition: "min-height 0.3s ease",
                }}
              >
                <div className="row g-0">
                  <div className="col-md-4">
                    <img
                      loading="lazy"
                      src={developerlogo}
                      className="img-fluid rounded-start"
                      alt="Avenue18-logo"
                      style={{ padding: "15px", marginTop: "25px" }}
                    />
                  </div>
                  <div className="col-md-8">
                    <div className="card-body">
                      <h3 className="card-title">Developed By</h3>
                      <h5 className="card-title">Makkaan Development</h5>
                      <p>
                        Makkaan development's first-ever commercial project,
                        located at the heart of the city, sets a new standard
                        for business spaces with its prime location, modern
                        architecture, customizable layouts,
                      </p>
                      {isExpandedDevelopedBy && (
                        <p>
                          state-of-the-art facilities, and eco-friendly
                          construction practices.Backed by a dedicated team of
                          professionals, we ensure on-time delivery, exceptional
                          quality, and a customer-centric approach to meet the
                          evolving needs of businesses.
                        </p>
                      )}
                      <a
                        onClick={toggleDevelopedBy}
                        style={{ color: "green", cursor: "pointer" }}
                      >
                        {isExpandedDevelopedBy ? "Read Less" : "Read More"}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}

export default Avenue18;
